import { useBooleanState } from '@cian/react-utils';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { AdfoxBanner } from 'shared/components/AdfoxBanner';
import { BuzzoolaBannerContainer } from 'shared/components/BuzzoolaBanner';
import { AdfoxContextProvider, TAdfoxContextProviderProps } from 'shared/context/AdfoxContext';
import {
  useNewbuildingBuzzoolaFirstEnabled,
  useNewbuildingBuzzoolaIntegrationAsStubEnabled,
  useNewbuildingBuzzoolaIntegrationTestWebBuzzoolaGroup,
  useNewbuildingBuzzoolaIntegrationTestWebExpEnabled,
} from 'shared/hooks/selectors/useNewbuildingBuzzoolaIntegrationTestWebAvailable';
import { selectIsNewbuildingPremiumRate } from 'shared/selectors/newbuildingPremiumRate';

/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
 * Если переходим на базуллу, то удалить.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const POST_VIEW_ANALYTICS_DATA: TAdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'TgbBottomBanners',
};
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
 * Если переходим на базуллу, то удалить.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const P_PARAMS: TAdfoxContextProviderProps['pParams'] = { p1: 'ddcga', p2: 'fkhj' };
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
 * Если переходим на базуллу, то удалить.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const SIZE: TAdfoxContextProviderProps['size'] = { width: '100%', height: 276 };
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
 * Если переходим на базуллу, то оставить как есть.
 * Если остаёмся на адфоксе, то удалить.
 */
const PLACEMENT_ID = 1299023;

/**
 * @todo Удалить компонент
 * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
 */
const TGBBannerExp: FC = () => {
  const isBuzzoolaGroup = useNewbuildingBuzzoolaIntegrationTestWebBuzzoolaGroup();

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
   * Если переходим на базуллу, то этот компонент с этипи пропсами переносим в TGBBanner.
   * Если не переходим, то просто всё в этом компоненте удалится.
   */
  if (isBuzzoolaGroup) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        placementId={PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  return (
    <AdfoxContextProvider
      bannerPlace="bottom"
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      size={SIZE}
      pParams={P_PARAMS}
    >
      <AdfoxBanner />
    </AdfoxContextProvider>
  );
};

/**
 * @todo Удалить компонент
 * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
 */
const TGBBannerStub: FC = () => {
  const { state, setTrue } = useBooleanState(false);

  if (state) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        placementId={PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  return (
    <AdfoxContextProvider
      bannerPlace="bottom"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    >
      <AdfoxBanner onStub={setTrue} />
    </AdfoxContextProvider>
  );
};

export const TgbBottomBannersContainer: React.FC = () => {
  const isBuzzoolaExpEnabled = useNewbuildingBuzzoolaIntegrationTestWebExpEnabled();
  const isBuzzoolaAsStubEnabled = useNewbuildingBuzzoolaIntegrationAsStubEnabled();
  const isBuzzoolaFirstEnabled = useNewbuildingBuzzoolaFirstEnabled();

  const isPremiumNewbuilding = useSelector(selectIsNewbuildingPremiumRate);

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-246146, будет удалён в задаче CD-245101
   * Если переходим на базуллу, то оставить как есть.
   * Если остаёмся на адфоксе, то удалить, так как это условие уже есть в контексте адфокса.
   */
  if (isPremiumNewbuilding) {
    return null;
  }

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
   * Если переходим на базуллу, то выносим компонент базуллы BuzzoolaBannerWithHide сюда,
   * ветвление в любом случае удаляется, компонента TGBBannerExp не должно быть.
   */
  if (isBuzzoolaExpEnabled) {
    return <TGBBannerExp />;
  }

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
   * Тут логику ветвления полностью убираем, так как тут просто включение базулы на постоянной основе, а результатом будет эксперимент,
   * это для того, что бы можно было включить баннеры для тестирования и подобных кейсов
   */
  if (isBuzzoolaFirstEnabled) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        placementId={PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
   * Тут удаляем в любом случае, так как это промежуточная логика пилота, этой логики по планам не будет в стабильном коде.
   * Будет или только адфокс или базулла.
   */
  if (isBuzzoolaAsStubEnabled) {
    return <TGBBannerStub />;
  }

  return (
    <AdfoxContextProvider
      bannerPlace="bottom"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    >
      <AdfoxBanner />
    </AdfoxContextProvider>
  );
};
